import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import logo from '../../../../images/thoot.png';
import {createUser, getUserCreateSuccessAction, getUserCreateFailureAction, resendEmail} from "./actions";
import {connect} from 'react-redux';
import SiteFoot from '../../../../shared/components/footer/index';
import ModalComponent from '../../../../components/Modal';
import Notice from '../../../../components/Notification/newNotification';
import ReCAPTCHA from "react-google-recaptcha";

class Registration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalShown: false,
            user: {
                email: '',
                re_email: '',
                first_name: '',
                last_name: '',
                password: '',
                re_password: '',
                business_name: '',
                business_phone: '',
                recaptcha: '',
            },
            errors: {
                title: 'Something went wrong.',
                message: 'Please try again later.',
                level: 'error',
                show: undefined
            },
            validation: {
                email: {message: ''},
                first_name: {message: ''},
                last_name: {message: ''},
                password: {message: ''},
                re_password: {message: ''},
                re_email: {message: ''},
                business_name: {message: ''},
                business_phone: {message: ''},
                recaptcha: {message: ''}
            },
            registerButtonDisable: true,
        };
        this.toggle = this.toggle.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.validatePassword = this.validatePassword.bind(this);
        this.validateWebsite = this.validateWebsite.bind(this);
        this.validations = this.validations.bind(this);
    }

    componentDidMount() {
        document.title = "Registration to Kerenor booking";
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.resendEmailSuccess){
            Notice.addNotification('The email was successfully resent.','success')
        }
    }

    handleBlur(key, value) {
        if (!this.state.registerButtonDisable) {
            let validationObject = this.validations(key, value);
            this.setState({validation: validationObject})
        }
    }

    validateWebsite(value) {
        if (value.length === 0) {
            return true;
        }
        var urlRegex = '^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';
        var url = new RegExp(urlRegex, 'i');
        return value.length < 2083 && url.test(value);
    }

    validatePassword(value, repeat = false) {
        let returnValue = false;
        if (!repeat) {
            if (value && value.length >= 6) {
                returnValue = true;
            }
        } else {
            let firstPassword = this.state.user.password;
            if (firstPassword === value) {
                returnValue = true;
            }
        }
        return returnValue;
    }

    validateRequired(value) {
        let returnValue = false;
        if (value && typeof value === "string" && value.trim().length === 0) {
            returnValue = false;
        } else if (value && value.length !== 0) {
            returnValue = true;
        }
        return returnValue;
    }

    validateEmail(email, repeat = false) {
        let returnValue = false;
        if (!repeat) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        } else {
            let firstEmail = this.state.user.email;
            if (firstEmail === email) {
                returnValue = true;
            }
        }
        return returnValue;
    }

    validations(key, value) {
        let specialKeys = ['email', 'password', 're_password', 're_email'];
        let validationObject = this.state.validation;
        let validation;
        if (specialKeys.indexOf(key) >= 0) {
            switch (key) {
                case 'email':
                    validation = this.validateEmail(value);
                    validationObject.email = {
                        valid: validation,
                        message: (!validation) ? 'Please enter a valid email.' : ''
                    }
                    validation = value === this.state.user.re_email;
                    validationObject.re_email = {
                        valid: validation,
                        message: (!validation) ? 'Your email do not match.' : ''
                    };
                    break;
                case 'password':
                    validation = this.validatePassword(value);
                    validationObject.password = {
                        valid: validation,
                        message: (!validation) ? 'Password must be at least 6 characters.' : ''
                    }
                    validation = value === this.state.user.re_password;
                    validationObject.re_password = {
                        valid: validation,
                        message: (!validation) ? 'Your passwords do not match.' : ''
                    };
                    break;
                case 're_password':
                    validation = this.validatePassword(value, true);
                    validationObject.re_password = {
                        valid: validation,
                        message: (!validation) ? 'Your passwords do not match.' : ''
                    };
                    break;
                case 're_email' :
                    validation = this.validateEmail(value, true)
                    validationObject.re_email = {
                        valid: validation,
                        message: (!validation) ? 'Your email do not match.' : ''
                    };
                    break;
                case 'recaptcha':
                    validation = this.validateWebsite(value);
                    validationObject.recaptcha = {
                        valid: validation,
                        message: (!validation) ? 'Please fill recaptcha field.' : ''
                    }
                    break;
                default: break;
            }
        } else {
            validation = this.validateRequired(value);
            validationObject[key] = {
                valid: validation,
                message: (!validation) ? 'This field is required.' : ''
            }
        }
        return validationObject;
    }

    handleChange(key, value) {
        let validationObject = this.validations(key, value);
        let notValid = false;
        for (const key of Object.keys(validationObject)) {
            if (validationObject[key].valid === undefined || !validationObject[key].valid) {
                notValid = true
                break;
            }
        }

        var {user} = this.state;
        user[key] = typeof value === "string" ? value.trim() : value;
        this.setErrorMessageStatus();
        this.setState({user, validation: validationObject, registerButtonDisable: notValid});
    }

    handleSubmit() {
        var {user} = this.state;
        this.props.createUser({user});
    }

    setErrorMessageStatus(status = false) {
        var object = this.state.errors;
        object['show'] = status;
        this.setState({
            errors: object
        })
    }

    toggle() {
        this.setState({
            modalShown: !this.state.modalShown
        });
    }

    componentWillReceiveProps(nextProps) {
        const {addIsSuccess} = nextProps.store;
        const {validation} = nextProps.store;
        const clonedObject = JSON.parse(JSON.stringify(this.state.validation));
        const newObject = Object.assign({}, clonedObject, validation);
        if (addIsSuccess) {
            this.setState({modalShown: true});
        }

        this.setState({validation: newObject});
        this.setErrorMessageStatus((addIsSuccess === false));
        if(nextProps.store.resendEmailResponse && nextProps.store.resendEmailResponse.error) {
            Notice.addNotification('You have already verified your email. Please sign in.', 'error');
            this.props.history.push('/sign-in');
        }
    }

    resendEmail() {
        const email = this.state.user.email;
        if(email) {
            this.props.resendEmail(email);
        }
    }

    render() {
        return (
            <div className="sign-in">
                <div className="sign-in__container">
                    <div className="main-block register">
                        <div className="main-block__logo">
                            <Link to="/">
                                <img src={logo} alt="Kerenor Booking" width="300"/>
                            </Link>
                        </div>
                        <div className='main-block__title'>
                            <h2>CREATE ACCOUNT</h2>
                        </div>
                        <div className="main-block__form">
                            <form>
                                <div className="register__block">
                                    <div className="register__item">
                                        <span className="register__title">PERSONAL INFORMATION</span>
                                        <div
                                            className={(this.state.validation.first_name.valid === undefined || this.state.validation.first_name.valid) ? "text-field" : "text-field has-error"}
                                        >
                                            <label className="text-field__label" htmlFor="">First Name</label>
                                            <input
                                                placeholder="First name"
                                                type="text"
                                                className="text-field__input"
                                                onBlur={(e) => this.handleBlur('first_name', e.target.value)}
                                                onChange={(e) => this.handleChange('first_name', e.target.value)}
                                            />
                                            <span
                                                className="error-message">{this.state.validation.first_name.message}</span>
                                        </div>
                                        <div
                                            className={(this.state.validation.last_name.valid === undefined || this.state.validation.last_name.valid) ? "text-field" : "text-field has-error"}
                                        >
                                            <label className="text-field__label" htmlFor="">Last Name</label>
                                            <input
                                                placeholder="Last name"
                                                type="text"
                                                className="text-field__input"
                                                onBlur={(e) => this.handleBlur('last_name', e.target.value)}
                                                onChange={(e) => this.handleChange('last_name', e.target.value)}
                                            />
                                            <span
                                                className="error-message">{this.state.validation.last_name.message}</span>
                                        </div>
                                        <div
                                            className={(this.state.validation.email.valid === undefined || this.state.validation.email.valid) ? "text-field" : "text-field has-error"}
                                        >
                                            <label className="text-field__label" htmlFor="">Email Address</label>
                                            <input
                                                placeholder="someone@xyz.com"
                                                type="email"
                                                className="text-field__input"
                                                autoFocus={true}
                                                onBlur={(e) => this.handleBlur('email', e.target.value)}
                                                onChange={(e) => this.handleChange('email', e.target.value)}
                                            />
                                            <span className="error-message">{this.state.validation.email.message}</span>
                                        </div>
                                        <div
                                            className={(this.state.validation.re_email.valid === undefined || this.state.validation.re_email.valid) ? "text-field" : "text-field has-error"}
                                        >
                                            <label className="text-field__label" htmlFor="">Retype Email</label>
                                            <input
                                                placeholder="Retype Email"
                                                type="email"
                                                className="text-field__input"
                                                onBlur={(e) => this.handleBlur('re_email', e.target.value)}
                                                onChange={(e) => this.handleChange('re_email', e.target.value)}
                                            />
                                            <span
                                                className="error-message">{this.state.validation.re_email.message}</span>
                                        </div>
                                        <div
                                            className={(this.state.validation.password.valid === undefined || this.state.validation.password.valid) ? "text-field" : "text-field has-error"}
                                        >
                                            <label className="text-field__label" htmlFor="">Password</label>
                                            <input
                                                placeholder="Password"
                                                type="password"
                                                className="text-field__input"
                                                onBlur={(e) => this.handleBlur('password', e.target.value)}
                                                onChange={(e) => this.handleChange('password', e.target.value)}
                                            />
                                            <span
                                                className="error-message">{this.state.validation.password.message}</span>
                                        </div>
                                        <div
                                            className={(this.state.validation.re_password.valid === undefined || this.state.validation.re_password.valid) ? "text-field" : "text-field has-error"}
                                        >
                                            <label className="text-field__label" htmlFor="">Retype Password</label>
                                            <input
                                                placeholder="Retype Password"
                                                type="password"
                                                className="text-field__input"
                                                onBlur={(e) => this.handleBlur('re_password', e.target.value)}
                                                onChange={(e) => this.handleChange('re_password', e.target.value)}
                                            />
                                            <span
                                                className="error-message">{this.state.validation.re_password.message}</span>
                                        </div>
                                    </div>
                                    <div className="register__item">
                                        <span className="register__title">BUSINESS INFORMATION</span>
                                        <div
                                            className={(this.state.validation.business_name.valid === undefined || this.state.validation.business_name.valid) ? "text-field" : "text-field has-error"}
                                        >
                                            <label className="text-field__label" htmlFor="">Name of Clinic</label>
                                            <input
                                                placeholder="Business Name"
                                                type="text"
                                                className="text-field__input"
                                                onBlur={(e) => this.handleBlur('business_name', e.target.value)}
                                                onChange={(e) => this.handleChange('business_name', e.target.value)}
                                            />
                                            <span className="error-message">{this.state.validation.business_name.message}</span>
                                        </div>
                                            <div
                                                className={(this.state.validation.business_phone.valid === undefined || this.state.validation.business_phone.valid) ? "text-field" : "text-field has-error"}
                                            >
                                                <label className="text-field__label" htmlFor="">Phone Number</label>
                                                <input
                                                    placeholder="514-222-2222"
                                                    className="text-field__input"
                                                    type="number"
                                                    onBlur={(e) => this.handleBlur('business_phone', e.target.value)}
                                                    onChange={(e) => this.handleChange('business_phone', e.target.value)}
                                                />
                                                <span className="error-message">{this.state.validation.business_phone.message}</span>
                                            </div>
                                    </div>
                                </div>
                                <div className="text-field recaptcha_block"> {/*add has-error for error styles*/}
                                    <ReCAPTCHA
                                        sitekey="6LdBtBgpAAAAAL748Vj11LeNirImMfw0p2vuOkGh"
                                        size="normal"
                                        onChange={(token) => this.handleChange('recaptcha', token)}
                                    />
                                    <span className="error-message">Error Message</span>
                                </div>
                            </form>
                            <ModalComponent
                                show={this.state.modalShown}
                                handleClose={this.toggle}
                                modalHeaderStyle="modalHeaderDefault"
                                headerTitle={"You have successfully registered"}
                                registeredUser={true}
                                resendEmail={() => this.resendEmail()}
                            />
                        </div>
                        <div className="main-block__buttons">
                            <button
                                className="btn btn-primary"
                                onClick={this.handleSubmit}
                                disabled={this.state.registerButtonDisable}
                            >
                                Register
                            </button>
                            <p>
                                Already have an account?
                                <Link to="/sign-in" className="btn btn-link">Sign In</Link>
                            </p>
                        </div>
                        <SiteFoot className="copyright"/>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = dispatch => {
    return {
        resendEmailSuccess: dispatch.register.resendEmailSuccess,
        getUserAddSuccess: (data) => dispatch(getUserCreateSuccessAction(data)),
        getUserAddFailure: (data) => dispatch(getUserCreateFailureAction(data)),
        store: dispatch.register
    }
}

const mapDispatchToProps = dispatch => {
    return {
        createUser: (data) => {
            dispatch(createUser(data));
        },
        resendEmail: (email) => {
            dispatch(resendEmail(email));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Registration);



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/Register/index.js